<template>
  <div class="rule-text-box" v-loading.fullscreen="isLoading">
    <div v-if="remoteContent" v-html="remoteContent"></div>
    <template v-else-if="lang === 'en-US'">
      <h2 align="center">Privacy Policy (simplified)</h2>
      <p align="center">&nbsp;</p>
      <p>
        Beijing Jingdong 360 Degree Electric Commerce Co., Ltd. (hereinafter
        referred to as “we”) fully recognizes the importance of personal
        information protection. This simplified Privacy Policy is intended to
        help you understand how we collect and process your personal information
        and how we protect your privacy in an intuitive and concise manner.
        Please refer to the full text of CIFTIS
        <a
          href="https://m-console.ciftis.org/agreement/privacy-policy"
          target="_blank"
          ><em>Privacy Policy</em></a
        >
        for details.
      </p>
      <p>
        <strong>I.</strong>&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >Personal Information Collected and Used for Providing
          Services</strong
        >
      </p>
      <p><strong>1. </strong>&nbsp; <strong>Signup and Login</strong></p>
      <p>
        Type of personal information:&nbsp;&nbsp; Network identification
        information (including account number, password, e-mail address);
        information (mobile phone number) filled out by the user.<strong
        ></strong>
      </p>
      <p><strong>2. </strong>&nbsp; <strong>2d system service</strong></p>
      <p>
        Type of personal information:&nbsp;&nbsp; Information, mobile phone
        number, and email address of the contact.<strong></strong>
      </p>
      <p><strong>3. </strong>&nbsp; <strong>Intent order service</strong></p>
      <p>
        Type of personal information:&nbsp;&nbsp; Information, mobile phone
        number, email and mailing address of the contact<strong></strong>
      </p>
      <p><strong>4. </strong>&nbsp; <strong>Electronic signing</strong></p>
      <p>
        Type of personal information:&nbsp;&nbsp; Name, mobile phone number, ID
        number of the authorized person
      </p>
      <p><strong>5. </strong>&nbsp; <strong>Big data analysis</strong></p>
      <p>
        Type of personal information:&nbsp;&nbsp; Name, mobile phone number and
        email address.
      </p>
      <p><strong>6. </strong>&nbsp; <strong>Booth sales system</strong></p>
      <p>
        Type of personal information:&nbsp;&nbsp; Enterprise contact and mobile
        phone number.
      </p>
      <p><strong>7. </strong>&nbsp; <strong>Project release</strong></p>
      <p>
        Type of personal information:&nbsp;&nbsp; Name, mobile phone number and
        address of the contact<strong></strong>
      </p>
      <p><strong>8. </strong>&nbsp; <strong>Achievements statistics</strong></p>
      <p>
        Type of personal information:&nbsp;&nbsp; Mobile phone number used for
        signup.<strong></strong>
      </p>
      <p><strong>9. </strong>&nbsp; <strong>Conference management</strong></p>
      <p>
        Type of personal information:&nbsp;&nbsp; Name, mobile phone number and
        email address of enterprise contact.<strong></strong>
      </p>
      <p><strong>10. </strong><strong>Live streaming</strong></p>
      <p>Type of personal information:&nbsp;&nbsp; Name and title of guest.</p>
      <p><strong>11. </strong><strong>Ticketing system</strong></p>
      <p>
        Type of personal information:&nbsp;&nbsp; Real name, nationality, type
        and number of badge, mobile phone number, workplace, position and email
        address of the user.<strong></strong>
      </p>
      <p>
        For details on how we collect your personal information, please refer to
        the
        <a href="https://m-console.ciftis.org/rule/collection" target="_blank"
          ><em>Checklist of Personal Information to Be Collected</em></a
        >.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>II.</strong>&nbsp;&nbsp;&nbsp;
        <strong>Permission Applied for Providing Services</strong
        ><strong></strong>
      </p>
      <p>
        We may apply for the use of your webcam (camera), photo album,
        microphone, contacts, calendar, phone, face ID / touch ID, location and
        other necessary permissions for scan, create live, live webcast and
        other functions.
      </p>
      <p>&nbsp;</p>
      <p>
        For the purpose of applying for the above permission, please refer to
        the
        <a href="https://m-console.ciftis.org/rule/permission" target="_blank"
          ><em>Application for App Permissions and Instructions for Use</em></a
        >.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>III.</strong>&nbsp;&nbsp;
        <strong>Personal Information Shared with Third Parties</strong
        ><strong></strong>
      </p>
      <p>
        We may share your personal information with affiliated companies,
        partners and other third parties for the successful provision of
        services for you, and we will constantly improve and enhance the
        security level of your personal information in accordance with the
        requirements of laws and regulations and industry best practices. We
        will strictly abide by the provisions of the Privacy Policy, and we will
        ask for your authorization and consent again when it comes to sharing of
        your sensitive personal information or new sharing party.
      </p>
      <p>
        For the types and purposes of personal information shared with third
        parties, please refer to “Checklist of Personal Information to Be Shared
        with Third Parties” in the
        <a href="https://m-console.ciftis.org/rule/sharing" target="_blank"
          ><em>Checklist of Shared Personal Information</em></a
        >.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>IV.</strong>&nbsp;&nbsp; <strong>Third-party SDKs</strong>: For
        the checklist of personal information collected by our embedded
        third-party codes and plug-ins, please refer to “Checklist of
        Third-Party SDKs" in the
        <a href="https://m-console.ciftis.org/rule/sharing" target="_blank"
          ><em>Checklist of Shared Personal Information</em></a
        >.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>V. </strong>&nbsp;
        <strong
          >Protection of Rights and Interests for User’s Personal
          Information</strong
        ><strong></strong>
      </p>
      <p>
        1. &nbsp; You can enable or disable APP access to camera through
        “<strong
          >Mine - Settings - Privacy Settings - Allow CIFTIS to access
          camera</strong
        >” on CIFTIS APP.
      </p>
      <p>
        2. &nbsp; You can enable or disable APP access to album through “<strong
          >Mine - Settings - Privacy Settings - Allow CIFTIS to access
          album</strong
        >” on CIFTIS APP.
      </p>
      <p>
        3. &nbsp; You can enable or disable APP access to microphone through
        “<strong
          >Mine - Settings - Privacy Settings - Allow CIFTIS to access
          microphone</strong
        >” on CIFTIS APP.
      </p>
      <p>
        4. &nbsp; You can enable or disable APP location permission through
        “<strong
          >Mine - Settings - Privacy Settings - Turn on geolocation</strong
        >” on CIFTIS APP.
      </p>
      <p>
        5. &nbsp; You can enable or disable APP access to Bluetooth through
        “<strong
          >Mine - Settings - Privacy Settings - Allow CIFTIS to access
          Bluetooth</strong
        >” on CIFTIS APP.
      </p>
      <p>
        6. &nbsp; You can enable or disable APP access to Phone through “<strong
          >Mine - Settings - Privacy Settings - Allow CIFTIS to access
          Phone</strong
        >” on CIFTIS APP.
      </p>
      <p>
        7. &nbsp; You may also revoke all of your authorization to allow us to
        continue collecting your personal information by canceling your CIFTIS
        account. You may access the “<strong
          >Mine - Personal Center (Profile photo icon) - Cancellation of
          Account</strong
        >” on mobile APP for the cancellation instructions and contact customer
        service to cancel your account.
      </p>
      <p>&nbsp;</p>
    </template>
    <template v-else>
      <h2 align="center">隐私政策（简要版）</h2>
      <p>
        首都会展（集团）有限公司（以下或称“我们”）深知个人信息保护的重要性，本隐私政策简要版本旨在帮助您直观、简明地了解我们是如何收集、处理个人信息以及如何保护您的隐私。更多详细信息请阅读完整的服贸会<a
          href="https://m-console.ciftis.org/agreement/privacy-policy"
          target="_blank"
          >《隐私政策》</a
        >。
      </p>
      <p align="left"><strong>一、为提供服务收集使用的个人信息</strong></p>
      <p align="left"><strong>1</strong><strong>、账号注册与登录</strong></p>
      <p align="left">
        个人信息类型：网络身份识别信息（包括账号、密码、电子邮箱）；用户自主填写的信息（手机号）。<strong
        ></strong>
      </p>
      <p align="left"><strong>2</strong><strong>、2d系统服务</strong></p>
      <p align="left">
        个人信息类型：联系人信息、手机号、邮箱<strong>。</strong>
      </p>
      <p align="left"><strong>3</strong><strong>、意向订单服务</strong></p>
      <p align="left">
        个人信息类型<strong>：</strong>联系人信息、手机号、邮箱，地址。<strong
        ></strong>
      </p>
      <p align="left"><strong>4</strong><strong>、电子签约</strong></p>
      <p align="left">个人信息类型：授权人姓名、手机号、身份证号。</p>
      <p align="left"><strong>5</strong><strong>、大数据分析</strong></p>
      <p align="left">个人信息类型：姓名、手机号、电子邮箱。</p>
      <p align="left"><strong>6</strong><strong>、展位销售系统</strong></p>
      <p align="left">个人信息类型：企业联系人、手机号。</p>
      <p align="left"><strong>7</strong><strong>、项目发布</strong></p>
      <p align="left">
        个人信息类型：联系人姓名、联系人手机号、联系人邮箱。<strong></strong>
      </p>
      <p align="left"><strong>8</strong><strong>、成果统计</strong></p>
      <p align="left">个人信息类型：注册手机号。<strong></strong></p>
      <p align="left"><strong>9</strong><strong>、会议管理</strong></p>
      <p align="left">
        个人信息类型：企业联系人姓名、手机号、电子邮箱。<strong></strong>
      </p>
      <p align="left"><strong>10</strong><strong>、直播</strong></p>
      <p align="left">个人信息类型：嘉宾姓名、嘉宾头衔。</p>
      <p align="left"><strong>11</strong><strong>、票务系统</strong></p>
      <p align="left">
        个人信息类型：用户真实姓名、国籍、证件类型、证件号码、联系手机、所在单位、职务、邮箱。<strong
        ></strong>
      </p>
      <p align="left">
        关于我们如何收集您的个人信息，详见<a
          href="https://m-console.ciftis.org/rule/collection"
          target="_blank"
          >《个人信息收集清单》</a
        >
        。
      </p>
      <p align="left">&nbsp;</p>
      <p align="left"><strong>二、为提供服务申请使用的权限</strong></p>
      <p align="left">
        为实现扫一扫、创建直播、在线直播及其他功能，我们可能会申请使用您的以下权限：摄像头（相机）、相册、麦克风、通讯录、日历、电话、面容ID/触控ID、位置及其他必要权限。
      </p>
      <p align="left">&nbsp;</p>
      <p align="left">
        我们申请使用上述权限的目的详见<a
          href="https://m-console.ciftis.org/rule/permission"
          target="_blank"
          >《应用权限申请与使用情况说明》</a
        >
        。
      </p>
      <p align="left">&nbsp;</p>
      <p align="left"><strong>三、与第三方共享的个人信息</strong></p>
      <p align="left">
        为保障向您提供的服务顺利完成，我们可能会向关联公司、合作伙伴等第三方共享您的个人信息，我们将根据法律法规要求并参照行业最佳实践，不断完善和提升对您个人信息的安全保障水平。我们严格遵循隐私权政策的约定，一旦涉及共享您的个人敏感信息或新增共享方，我们将再次征求您的授权同意。
      </p>
      <p align="left">
        我们与第三方共享的个人信息类型和目的，详见<a
          href="https://m-console.ciftis.org/rule/sharing"
          target="_blank"
          >《个人信息共享清单》</a
        >&nbsp; 中的“与第三方共享个人信息列表”。
      </p>
      <p align="left">&nbsp;</p>
      <p align="left">
        <strong>四、第三方SDK:</strong
        >我们嵌入的第三方代码、插件收集的个人信息列表，详见<a
          href="https://m-console.ciftis.org/rule/sharing"
          target="_blank"
          >《个人信息共享清单》</a
        >&nbsp; 中的“SDK列表”。
      </p>
      <p align="left">&nbsp;</p>
      <p align="left"><strong>五、用户个人信息权益保障</strong></p>
      <p align="left">
        1、您可以通过服贸会APP“<strong>我的-设置-隐私设置-允许服贸会访问相机</strong>”开启或关闭程序访问相机权限。
      </p>
      <p align="left">
        2、您可以通过服贸会APP“<strong>我的-设置-隐私设置-允许服贸会访问相册</strong>”开启或关闭程序访问相册权限。
      </p>
      <p align="left">
        3、您可以通过服贸会APP“<strong>我的-设置-隐私设置-允许服贸会使用麦克风</strong>”开启或关闭程序使用麦克风权限。
      </p>
      <p align="left">
        4、您可以通过服贸会APP“<strong>我的-设置-隐私设置-开启地理位置定位</strong>”开启或关闭程序定位权限。
      </p>
      <p align="left">
        5、您可以通过服贸会APP“<strong>我的-设置-隐私设置-允许服贸会访问蓝牙</strong>”开启或关闭程访问蓝牙权限。
      </p>
      <p align="left">
        6、您可以通过服贸会APP“<strong>我的-设置-隐私设置-允许服贸会访问电话</strong>”开启或关闭程访问电话权限。
      </p>
      <p align="left">
        7、您也可以通过注销服贸会账号的方式，撤回我们继续收集您个人信息的全部授权。您可以通过移动端APP访问“<strong>我的-个人中心（头像图标）-注销账号</strong>”查看注销须知，联系客服注销账号。
      </p>
    </template>
  </div>
</template>

<script>
import { getPolicyDetailById } from '@/api/newscenter-api'
import { getLang } from '@/utils'

export default {
  data() {
    return {
      locale: this.$route.query.lang == 'en' ? 'en-US' : '',
      lang: 'zh-CN',
      remoteContent: '',
      isLoading: true
    }
  },
  created() {
    const detectedLang = this.locale ? this.locale : getLang()
    if (detectedLang) {
      this.lang = detectedLang
    }
    this.loadContent()
  },
  methods: {
    async loadContent() {
      const {
        VUE_APP_SIMPLE_PRIVACY_ID = '',
        VUE_APP_SIMPLE_PRIVACY_EN_ID = ''
      } = process.env

      const targetId =
        this.lang === 'en-US'
          ? VUE_APP_SIMPLE_PRIVACY_EN_ID || VUE_APP_SIMPLE_PRIVACY_ID
          : VUE_APP_SIMPLE_PRIVACY_ID

      if (!targetId) {
        this.isLoading = false
        return
      }

      this.isLoading = true
      try {
        const response = await getPolicyDetailById(targetId, this.lang)
        const richText = this.extractRichText(response)
        if (richText && richText.trim().length > 0) {
          this.remoteContent = richText
        }
      } catch (error) {
        // Fallback to bundled content on failure.
      } finally {
        this.isLoading = false
      }
    },
    extractRichText(response) {
      const result = response && response.result
      if (!result) {
        return ''
      }

      const container = result.content || result.data
      if (container && container.richText) {
        return container.richText.replace(
          /text-wrap-mode:\s*nowrap/g,
          'text-wrap-mode: wrap'
        )
      }

      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep table {
  border-collapse: collapse;
}
.rule-text-box {
  max-width: 1200px;
  width: 100%;
  margin: 20px auto;
  padding: 30px;
  background: #fff;
  font-size: 14px;
  line-height: 28px;
  overflow-x: auto;
  overflow-wrap: break-word;
  word-break: break-word;
  -webkit-overflow-scrolling: touch;
  h2 {
    margin: 0 0 32px;
    padding: 0 0 20px;
    border-bottom: 1px solid #eee;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }
  hr {
    margin: 20px 0;
  }
  a {
    color: #0175d4;
    text-decoration: underline;
  }
  table {
    width: 100%;
    margin: 12px 0;
    border-collapse: collapse;
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  th,
  td {
    padding: 6px 4px;
    border: 1px solid #ccc;
    background: #fff;
    white-space: normal;
    word-break: break-word;
  }
  th {
    background: #f5f5f5;
  }
  img {
    max-width: 100%;
    height: auto;
  }
}
@media screen and (max-width: 800px) {
  .rule-text-box {
    width: 100%;
    margin: 0;
    padding: 15px;
    line-height: 28px;
    h2 {
      margin: 6px 0 10px;
      padding: 0;
      border-bottom: none;
      font-size: 20px;
      line-height: 36px;
    }
  }
}
</style>
